module.exports = __webpack_public_path__ + "static/civic-logo-stack_standard-d9ee94c8b791c2a93a70c1e26cb7cb3e.svg";